import React, { Component } from "react"

function infiniteScroller(WrappedComponent) {
    return class extends Component {
        constructor(props) {
            super(props)
            this.onScroll = this.onScroll.bind(this)
            this.previousScrollAmount = 0
            this.scrollPercentageThreshold = 0.8
        }

        componentDidMount() {
            const { isFetching, requestMoreData, pagingRequest } = this.props
            // isPossibleNextPage may be undefined if not yet requested,
            // so check specifically for false
            if (!isFetching) {
                requestMoreData({
                    ...(pagingRequest || {}),
                    offset: 0,
                    nextOffset: 0
                })
            }
        }

        componentDidUpdate(previousProps) {
            const {
                isFetching,
                shouldRefreshCriteria,
                pagingRequest,
                requestMoreData
            } = this.props

            if (
                shouldRefreshCriteria &&
                previousProps.shouldRefreshCriteria &&
                !isFetching
            ) {
                const shouldRequest = Object.keys(shouldRefreshCriteria).some(
                    key =>
                        shouldRefreshCriteria[key] !==
                        previousProps.shouldRefreshCriteria[key]
                )
                if (shouldRequest) {
                    requestMoreData({
                        ...(pagingRequest || {}),
                        offset: 0,
                        nextOffset: 0
                    })
                }
            }
        }

        onScroll(event) {
            const {
                scrollTop,
                scrollHeight,
                offsetHeight
            } = event.currentTarget
            const { isFetching, pagingRequest, requestMoreData } = this.props
            const { isPossibleNextPage, nextOffset, offset } = pagingRequest
            if (!isFetching && isPossibleNextPage !== false) {
                if (
                    scrollTop > this.previousScrollAmount &&
                    scrollTop >
                        (scrollHeight - offsetHeight) *
                            this.scrollPercentageThreshold
                ) {
                    requestMoreData({
                        ...pagingRequest,
                        offset: nextOffset || offset
                    })
                }
            }
            this.previousScrollAmount = scrollTop
        }

        render() {
            return <WrappedComponent {...this.props} onScroll={this.onScroll} />
        }
    }
}

export default infiniteScroller
